export const SEO_EVENTS = {
    aiReferralVisit: 'AI Referral Visit'
} as const;

export type SeoAnalyticsEvents = {
    'AI Referral Visit': {
        provider: string;
        landingPage: string;
    };
};

type AiReferralProps = SeoAnalyticsEvents['AI Referral Visit'];

export function detectAiProvider(referrer: string, utmSource: string) {
    const signal = `${referrer} ${utmSource}`.toLowerCase();
    const providers = [
        { name: 'ChatGPT', patterns: ['chatgpt.com', 'openai.com'] },
        { name: 'Claude', patterns: ['claude.ai', 'anthropic.com'] },
        { name: 'Perplexity', patterns: ['perplexity.ai'] },
        { name: 'Microsoft Copilot', patterns: ['copilot.microsoft.com'] },
        { name: 'Google Gemini', patterns: ['gemini.google.com'] }
    ];

    return providers.find((provider) =>
        provider.patterns.some((pattern) => signal.includes(pattern))
    )?.name;
}

export function trackAiReferralVisit(
    plausible: (
        eventName: typeof SEO_EVENTS.aiReferralVisit,
        options: { props: AiReferralProps }
    ) => unknown,
    props: AiReferralProps
) {
    return plausible(SEO_EVENTS.aiReferralVisit, { props });
}
